import React from 'react'

import './admin/DemoForm.scss'

export interface LabeledFieldProps {
  label: string
  children: React.ReactNode
}

export const LabeledField = ({ label, children }: LabeledFieldProps) => {
  return (
    <div className='demo-form__field'>
      <label>{label}</label>
      {children}
    </div>
  )
}
